import { CommentAccountIcon } from './CommentAccountIcon';

/**
 * author: Austin Andrews
 * id E0D4328B-7A71-46E7-804B-DFC3753BEDF6
 * name comment-account
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/comment-account.svg
 * tags
 * - Account / User 
 */
export const CommentPersonIcon = CommentAccountIcon;
export default CommentPersonIcon